import { gql } from "@apollo/client";import { useLazyQuery, useMutation } from "@apollo/client/react";import React, { useEffect, useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import { useForm } from '../../../components/hooks/useForm';
import FormControl from '@mui/material/FormControl';
import CheckIcon from '@mui/icons-material/Check';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DownloadIcon from '@mui/icons-material/Download';
import toast, { Toaster } from 'react-hot-toast';
import DocumentViewer from '../../../components/DocumentViewer';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { APPCONFIG } from '../../../app.config';
import ErrorDialog from '../../../components/ErrorDialog';
import { CircularProgress } from "@mui/material";
import fileDownload from 'js-file-download';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';
import { CustomButton } from '../../../components/customButton/CustomButton';

export default function Referenciados() {

  const RESULTADO_SAP = 'SAP';
  const RESULTADO_CAM = 'CAM';
  const COLOR_OK = 'green';
  const COLOR_ERROR = 'red';

  const [result, setResult] = useState('-');
  const [resultPed, setResultPed] = useState('-');
  const [colorMsg, setCologMsg] = useState('');
  const [disabledBtnValidar, setDisabledBtnValidar] = useState(false);
  const [showGrilla, setShowGrilla] = useState(false);
  const [accion, setAccion] = useState('');

  const [data, setData] = useState([]);

  // upload
  const [fileSelected, setFileSelected] = useState();
  const [isFilePicked, setIsFilePicked] = useState(false);

  // dlg visualización
  const [filePreview, setFilePreview] = useState([]);
  const [openDlg, setOpenDlg] = useState(false);

  // dlg confimración
  const [openDlgConfirm, setOpenDlgConfirm] = useState(false);

  // Log de errores
  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
    clickClear();
  };

  let toastId = 0;
  const textInputRemito = useRef(null);

  const Input = styled('input')({
    display: 'none'
  });

  const [formValues, formHandle, setFormValues] = useForm({
    Remito: ''
  });

  useEffect(() => {
    textInputRemito.current.focus();
  }, []);

  const isValid = () => {
    let resultado = true;
    let mensaje = 'OK';

    // Remito
    if (formValues.Remito === "") {
      textInputRemito.current.focus();
      return {
        resultado: false,
        mensaje: "El Remito es obligatorio."
      };
    }

    return { success: resultado, mensaje: mensaje };
  };

  const clickCheck = () => {
    const validacion = isValid();
    if (validacion.success) {
      buscarRemito(formValues.Remito);
    } else {
      setResult(validacion.mensaje);
      setCologMsg(COLOR_ERROR);
    }
  };

  // INICIO - BUSCAR REMITO

  const QBuscarRemito = gql`
        query QBuscarRemito ($remito: String!) {
            buscarRemito 
            (
                remito: $remito,
            
            ) 
            {
                success,
                error,
                valorEsperado {
                    numeroRemito,
                    idOrdenPedido,
                    origen
                } 
            }
        }`;

  const [getBuscarRemito, { data: dataRemito, error: errorRemito }] = useLazyQuery(QBuscarRemito, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataRemito) return;
    if (dataRemito.buscarRemito.success) {
      const remito = dataRemito.buscarRemito.valorEsperado;
      if (remito !== null) {
        setDisabledBtnValidar(true);
        setCologMsg(COLOR_OK);
        setResult(remito.origen);
        setResultPed(remito.idOrdenPedido);

        getDocumentoAsociado(formValues.Remito);
      } else {
        setResult(dataRemito.buscarRemito.error);
        setResultPed("");
        setData([]);
      }
    } else {
      setCologMsg(COLOR_ERROR);
      setResult("No se encontró el remito.");
      setMensajeError(dataRemito.buscarRemito.error);
    }
  }, [dataRemito]);


  useEffect(() => {
    if (!errorRemito) return;
    setCologMsg(COLOR_ERROR);
    setMensajeError("ERRORDB");
  }, [errorRemito]);


  const buscarRemito = (remito) => {
    getBuscarRemito({ variables: { remito: remito, idConsulta: Math.random() } });
  };

  // FIN - BUSCAR REMITO

  // INICIO - DOCUMENTO ASOCIADO 

  const QGetArchivo = gql`
        query QGetArchivo ($remito: String!) {
            archivoRemito
            (
                remito: $remito,
            ) 
            {
                success,
                error,
                valorEsperado {
                    idArchivo,
                    numeroRemito,
                    idOrdenPedido,
                    fechaAlta,
                    titulo,
                    contentType,
                    extension,
                    archivo
                } 
            }
        }`;

  const [getArchivoQuery, { data: dataFile, error: errorFile }] = useLazyQuery(QGetArchivo, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataFile) return;
    toast.dismiss(toastId);
    if (dataFile.archivoRemito.success) {
      setShowGrilla(true);
      if (accion === 'VIEW') {
        setFilePreview(dataFile.archivoRemito.valorEsperado[0]);
        setOpenDlg(true);
      }

      if (accion === 'DOWNLOAD') {
        const arr = new Uint8Array(dataFile.archivoRemito.valorEsperado[0].archivo);
        const documento = new Blob([arr], { type: dataFile.archivoRemito.valorEsperado[0].contentType });
        const fileName = dataFile.archivoRemito.valorEsperado[0].titulo + dataFile.archivoRemito.valorEsperado[0].extension;

        fileDownload(documento, fileName);
      }

      if (accion === 'BORRAR') {
        setOpenDlgConfirm(true);
      }

    } else {
      setMensajeError(dataFile.archivoRemito.error);
    }
  }, [dataFile]);

  useEffect(() => {
    if (!errorFile) return;
    toast.dismiss(toastId);
    setMensajeError("ERRORDB");
  }, [errorFile]);


  const QGetTituloArchivoRemito = gql`
        query QGetTituloArchivoRemito ($remito: String!) {
            tituloArchivoRemito
            (
                remito: $remito,
            ) 
            {
                success,
                error,
                valorEsperado {
                    idArchivo,
                    numeroRemito,
                    idOrdenPedido,
                    fechaAlta,
                    titulo,
                    contentType,
                    extension,
                    archivo
                } 
            }
        }`;

  const [getDocumentoAsociadoQuery, { data: dataArchivo, error: errorArchivo }] = useLazyQuery(QGetTituloArchivoRemito, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataArchivo) return;
    toast.dismiss(toastId);
    if (dataArchivo.tituloArchivoRemito.success) {
      setShowGrilla(true);
      setData(dataArchivo.tituloArchivoRemito.valorEsperado);
    } else
    {
      setMensajeError(dataArchivo.tituloArchivoRemito.error);
    };
  }, [dataArchivo]);

  useEffect(() => {
    if (!errorArchivo) return;
    toast.dismiss(toastId);
    setMensajeError("ERRORDB");
  }, [errorArchivo]);

  const getDocumentoAsociado = (remito) => {
    setData([]);
    //toastId = toast.loading('Cargando...', { id: 'clipboard' });
    getDocumentoAsociadoQuery({ variables: { remito: remito, idConsulta: Math.random() } });
  };

  const getArchivo = (remito) => {
    getArchivoQuery({ variables: { remito: remito, idConsulta: Math.random() } });
  };

  // FIN - DOCUMENTO ASOCIADO

  // INICIO - SUBIR DOCUMENTO

  const MsubirDocumentoRemito = gql`
        mutation MsubirDocumentoRemito (
            $remito: String!, $idOrdenPedido: Int!, $contentType: String!, $titulo: String!, $archivo: [Byte!]!, $extension: String!) {
            subirDocumentoRemito 
            (
                remito: $remito,
                idOrdenPedido: $idOrdenPedido,
                contentType: $contentType,
                titulo: $titulo,
                archivo: $archivo,
                extension: $extension,
            )
            {
                success,
                error,
                valorEsperado
            }
        }`;

  const [subirDocumento, { data: dataSubirDocumento }] = useMutation(MsubirDocumentoRemito, {
    onCompleted: (dataSubirDocumento) => {
      if (dataSubirDocumento.subirDocumentoRemito.success) {
        if (dataSubirDocumento.subirDocumentoRemito.valorEsperado) {
          getDocumentoAsociado(formValues.Remito);
        } else {
          toast.error(dataSubirDocumento.subirDocumentoRemito.error);
        }
      } else {
        toast.dismiss(toastId);
        setMensajeError(dataSubirDocumento.subirDocumentoRemito.error);
      }
    },
    onError: (dataSubirDocumento) => {
      toast.dismiss(toastId);
      setMensajeError("ERRORDB");
    }
  });

  const handleChangeFile = (event) => {
    //toastId = toast.loading('Cargando...', { id: 'clipboard' });
    setShowGrilla(false);
    setFileSelected(event.target.files[0]);
    setIsFilePicked(true);
  };

  const isValidTipoArchivoAdjunto = () => {
    let sizeFile = fileSelected.size;
    if (sizeFile > APPCONFIG.SIZEARCHIVO.REMITO.SIZE) {
      return -1;
    }

    return APPCONFIG.TIPOADJUNTO.REMITO.some((e) => e === fileSelected.type);
  };

  useEffect(() => {
    if (isFilePicked) {
      let isValido = isValidTipoArchivoAdjunto();
      if (isValido > 0) {
        const reader = new FileReader();
        const fileByteArray = [];
        reader.readAsArrayBuffer(fileSelected);
        reader.onloadend = (evt) => {
          if (evt.target.readyState === FileReader.DONE) {
            const arrayBuffer = evt.target.result,
              array = new Uint8Array(arrayBuffer);
            for (const a of array) {
              fileByteArray.push(a);
            }

            subirDocumento({
              variables: {
                remito: formValues.Remito,
                idOrdenPedido: parseInt(resultPed, 10),
                titulo: result === RESULTADO_SAP ? resultPed : formValues.Remito,
                contentType: fileSelected.type,
                extension: "." + fileSelected.name.split(".")[1],
                archivo: fileByteArray
              }
            });
          }
        };


      } else {
        setShowGrilla(true);
        isValido == 0 ? toast.error("El tipo de archivo adjunto no está permitido.") :
        toast.error("El tamaño del archivo adjunto no está permitido, su máximo permitido es: " + APPCONFIG.SIZEARCHIVO.REMITO.INFO);
      }
      setIsFilePicked(false);
    }
  }, [isFilePicked]);

  // FIN - SUBIR DOCUMENTO

  // INICIO - ELIMINAR DOCUMENTO

  const handleAceptarEliminar = () => {
    setOpenDlgConfirm(false);
    borrarDocumento({ variables: { remito: formValues.Remito } });
  };

  const handleCancelarEliminar = () => {
    setOpenDlgConfirm(false);
  };

  const MBorrarArchivoRemito = gql`
        mutation MBorrarArchivoRemito ($remito: String!) {
            borrarArchivoRemito
            (
                remito: $remito
            )
            {
                success,
                error,
                valorEsperado
            }
        }`;

  const [borrarDocumento, { data: dataBorrarDocumento }] = useMutation(MBorrarArchivoRemito, {
    onCompleted: (dataBorrarDocumento) => {
      if (dataBorrarDocumento.borrarArchivoRemito.success) {
        // se eliminó el documento
        if (dataBorrarDocumento.borrarArchivoRemito.valorEsperado) {
          // se debería volver a consultar los documentos, pero se sabe que
          // solo puede haber como máximo 1 documento, por lo tanto para no volver
          // a consultar a la base sin sentido directamente seteamos los datos para la grilla en null
          setData([]);
        } else {
          toast.error(dataBorrarDocumento.borrarArchivoRemito.error);
        }
      } else {
        setMensajeError(dataBorrarDocumento.borrarArchivoRemito.error);
      }
    },
    onError: (dataBorrarDocumento) => {
      setMensajeError("ERRORDB");

    }
  });

  const handleBorrar = () => {
    setShowGrilla(false);
    setAccion('BORRAR');
    getArchivo(formValues.Remito);
  };

  // FIN - ELIMINAR DOCUMENTO

  const clickClear = () => {
    setFormValues({
      Remito: ""
    });
    textInputRemito.current.focus();
    setResult("-");
    setResultPed("-");
    setDisabledBtnValidar(false);
    setShowGrilla(false);
  };

  const handleView = () => {
    setShowGrilla(false);
    setAccion('VIEW');
    getArchivo(formValues.Remito);
  };

  const linkDescarga = () => {
    setShowGrilla(false);
    setAccion('DOWNLOAD');
    getArchivo(formValues.Remito);
  };

  const initialColumns = [
  {
    field: 'idArchivo',
    headerName: 'Id'
  },
  {
    field: 'titulo',
    headerName: 'Nombre'
  },
  {
    field: 'fechaAlta',
    headerName: 'Fecha'
  },
  {
    field: 'actions', headerName: 'Acciones', sortable: false,
    renderCell: (params) =>
    <>
                    <VisibilityIcon
        sx={{ color: '#717171', cursor: 'pointer', fontSize: '14pt' }}
        onClick={() => handleView()}
        titleAccess='Visualizar' />
                    <DeleteOutlineIcon
        sx={{ color: '#717171', cursor: 'pointer', fontSize: '14pt', marginLeft: '15px' }}
        onClick={() => handleBorrar()}
        titleAccess='Borrar' />
                    <button onClick={() => linkDescarga()} style={{ border: 'none', background: 'none' }}>
                        <DownloadIcon
          sx={{ color: '#717171', cursor: 'pointer', fontSize: '14pt', marginLeft: '15px', paddingTop: '5px' }}
          titleAccess='Descargar' />
                    </button>
                </>

  }];


  const columns = generateColumnsDefaultConfiguration(initialColumns);

  return (
    <>
            <FormControl variant="outlined" sx={{ display: 'block', alignItems: 'center' }} fullWidth>
                <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="center">
                    <div className="documento-encabezado" style={{ color: '#0063BE' }}>Remitos</div>
                    <div>
                        <TextField
              className="input-40"
              disabled={formValues.Ok}
              inputRef={textInputRemito}
              label="Numero Remito"
              name="Remito"
              onChange={formHandle}
              required
              size="small"
              type="text"
              value={formValues.Remito}
              variant="outlined" />
            
                    </div>
                    <br />
                    <div>
                        <CustomButton disabled={disabledBtnValidar} variant="contained" endIcon={<CheckIcon />} onClick={clickCheck}>
                            Validar
                        </CustomButton>&nbsp;&nbsp;
                        <Button variant="contained" endIcon={<CloseIcon />} onClick={clickClear}>
                            Cancelar
                        </Button>
                    </div>

                    <br />

                    <div style={{ display: 'flex', fontSize: '11pt', textAlign: 'center' }}>
                        <label style={{ fontWeight: 'bold', color: '#818181' }}>Origen: </label>&nbsp;
                        <label id="lblResul" style={{ color: colorMsg }}>{result}</label>
                    </div>

                    {showGrilla &&
          <>
                            <div style={{ display: 'flex', fontSize: '11pt', textAlign: 'center' }}>
                                <label style={{ fontWeight: 'bold', color: '#818181' }}>Id. Orden Pedido: </label>&nbsp;
                                <label id="lblResultPedido">{resultPed}</label>
                            </div>


                            <label htmlFor="icon-button-file">
                                <Input accept="image/jpeg,image/jpg,image/jfif,image/png,application/pdf" id="icon-button-file" type="file" onChange={handleChangeFile} />
                                <IconButton color="primary" aria-label="upload picture" component="span" size='large'>
                                    <CloudUploadIcon fontSize="inherit" />
                                </IconButton>
                            </label>

                            <div style={{ width: '100%' }}>
                                <DataGridGenerico
                id="DataRef"
                columns={columns}
                rows={data}
                toolbar={false}>
              </DataGridGenerico>
                            </div>
                        </>
          }

                    {(result === RESULTADO_SAP || result === RESULTADO_CAM) && !showGrilla &&
          <div class="loadingFullPage">
                            <div><CircularProgress disableShrink /><br />Cargando...</div>
                        </div>
          }

                </Grid>
                

            </FormControl>

            {openDlg && <DocumentViewer data={filePreview} setOpenDlg={setOpenDlg} />}


            <CustomDialog
        maxWidth="md"
        open={openDlgConfirm}
        title='Documento asociado'
        onCancel={handleCancelarEliminar}
        onAccept={handleAceptarEliminar}>
        
                ¿<strong>Está seguro de eliminar</strong> el documento seleccionado?
            </CustomDialog>
        </>);

}